import { Modal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type FinalWarningModalProps = {
  onRefresh: () => void
  onAcknowledged: () => void
  isOpen?: boolean
}

const FinalWarningModal = ({
  onRefresh,
  onAcknowledged,
  isOpen = false
}: FinalWarningModalProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <Modal
      localisation={{
        confirmText: t(generalConstants.CONFIRM),
        title: t(generalConstants.FINAL_WARNING_TITLE),
        cancelText: t(generalConstants.ClickHere)
      }}
      noPadding
      onConfirm={onAcknowledged}
      onCancel={onRefresh}
      isModalVisible={isOpen}
    >
      <ModalContentWrapper>
        <Text level={1} weight="bold">
          {t(generalConstants.FINAL_WARNING_MESSAGE)}
        </Text>
      </ModalContentWrapper>
    </Modal>
  )
}

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export default FinalWarningModal
